import { error } from "console";
import callApi, { BaseResponseDto } from "./baseRequest";

const route = 'veichle';

interface Veichle {
    id: string,
    tm: string,
    minValue: number, 
    maxValue: number,
    incoterm: string,
    veichleDescriptions: VeichleDescription[]
};

export interface VeichleCustomer {
    id?: string,
    veichleId: string,
    issuer: string,
    minValue: number, 
    maxValue: number,
    materialCode: string,
    incoterm: string,
    active: boolean,
    veichleDescriptions?: VeichleDescription[] | null
};

export interface VeichleDescription {
    description: string,
    veichleId: string,
    lang: string
}

export function getVeichlesByMaterial(material: string, incoterm?: string, isPVC?: boolean): Promise<BaseResponseDto<Veichle[]>> {
    const result: BaseResponseDto<Veichle[]> = {
        data: [],
        error: '',
        success: false
    };

    const response = callApi('GET', `${route}/${material}/?incoterms=${incoterm}&isPVC=${isPVC}`)
    .then(resp => {
        if (resp?.data) {
            result.data = resp?.data;
            result.success = true;
        }
        else {
            result.error = 'Veiculos não encontrados'
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function putNotifications(email: string): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        data: {},
        error: '',
        success: false
    };

    const response = callApi('PUT', `${route}/${email}`)
    .then(resp => {
        result.success = true;
        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function getVeichlesByCustomer(issuer: string): Promise<BaseResponseDto<VeichleCustomer[]>> {
    const result: BaseResponseDto<VeichleCustomer[]> = {
        data: [],
        error: '',
        success: false
    };

    const response = callApi('GET', `${route}/customer/${issuer}`)
    .then(resp => {
        if (resp?.data) {
            result.data = resp?.data;
            result.success = true;
        }
        else {
            result.error = 'Veiculos não encontrados'
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function postVeichlesByCustomer(data: VeichleCustomer): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        data: [],
        error: '',
        success: false
    };

    data.active = true;
    const response = callApi('POST', `${route}/customer`, data)
    .then(resp => {
        if (resp?.data) {
            result.data = resp?.data;
            result.success = true;
        }
        else {
            result.error = 'Veiculos não encontrados'
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};

export function putVeichlesByCustomer(data: VeichleCustomer): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        data: [],
        error: '',
        success: false
    };

    const response = callApi('PUT', `${route}/customer`, data)
    .then(resp => {
        if (resp?.data) {
            result.data = resp?.data;
            result.success = true;
        }

        return result;
    })
    .catch(err => {
        result.error = err;

        return result;
    })

    return response;
};